"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage"));

var _index = require("../index");

var _index2 = require("./index.styles");

var _Input = _interopRequireDefault(require("./Input"));

var _TextArea = _interopRequireDefault(require("./TextArea"));

var _excluded = ["type", "children", "showError"];

var TextInput = function TextInput(_ref) {
  var type = _ref.type,
      children = _ref.children,
      showError = _ref.showError,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useField = (0, _formik.useField)(props),
      _useField2 = (0, _slicedToArray2["default"])(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var hasError = typeof showError === 'undefined' ? meta.error && meta.touched : showError;
  var disabled = props.disabled;

  var handleClear = function handleClear() {
    helpers.setValue('');
    props.handleClear();
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_index2.StyledLabel, {
    disabled: disabled ? true : undefined
  }, children, /*#__PURE__*/_react["default"].createElement(_index2.StyledField, (0, _extends2["default"])({
    type: type,
    as: type === 'textarea' ? _TextArea["default"] : _Input["default"]
  }, field, {
    value: field.value || ''
  }, props, {
    handleClear: props.handleClear && handleClear,
    className: hasError ? 'invalid' : null
  }))), hasError ? /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
    "data-testid": "error-".concat(field.name)
  }, meta.error) : null);
};

TextInput.propTypes = {
  showError: _propTypes.bool,
  children: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
    type: (0, _propTypes.oneOf)([_index.FieldLabel])
  })]).isRequired,
  name: _propTypes.string.isRequired,
  type: (0, _propTypes.oneOf)(['text', 'textarea', 'number', 'email', 'password', 'tel', 'url', 'date']),
  size: (0, _propTypes.oneOf)(['xs', 's', 'm', 'l', 'xl']),
  disabled: _propTypes.bool,
  handleClear: _propTypes.func,
  clearTitle: _propTypes.string
};
TextInput.defaultProps = {
  size: 'm',
  type: 'text',
  disabled: false
};
var _default = TextInput;
exports["default"] = _default;